import { getCountFromServer, query, where } from "firebase/firestore";
import { getRefs } from "../ref";
import { TYPES } from "./task_count.type";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const auth = getAuth(app);

// đếm số trang.
export const getTotalTask = (callback) => async (dispatch) => {
  const cRef = getRefs().effort;
  const uid = auth?.currentUser?.uid;
  const c0 = where("supporterId", "==", uid);
  const qRef = query(cRef, c0);
  const snapshot = await getCountFromServer(qRef);
  const count = snapshot?.data().count || 0;

  setTotalTaskSuccess(dispatch, count);
  if (callback) {
    callback();
  }
};

export const getUnfinishedTask = (callback) => async (dispatch) => {
  const cRef = getRefs().dialog;
  const c0 = where("takeOverBy", "==", "none");
  const qRef = query(cRef, c0);
  const snapshot = await getCountFromServer(qRef);
  const count = snapshot?.data().count || 0;

  setUnfinishedTaskCount(dispatch, count);
  if (callback) {
    callback();
  }
};

const setUnfinishedTaskCount = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_UNFINISHED_TASK_COUNT,
    payload: data,
  });
};

const setTotalTaskSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TOTAL_TASK,
    payload: data,
  });
};
